module.exports = __webpack_public_path__ + "img/mdm-deploy-5.3abe05b8.jpg";